module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('h1', {
    staticClass: "publish",
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("发布")])]), _vm._v(" "), _c('div', {
    staticClass: "editWrapper"
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "height": 100,
      "rows": 5,
      "cols": 30,
      "placeholder": "说说这张照片",
      "max": 1000
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    attrs: {
      "title": _vm.confirm_title
    },
    on: {
      "on-confirm": _vm.onConfirm
    },
    model: {
      value: (_vm.showConfirm),
      callback: function($$v) {
        _vm.showConfirm = $$v
      },
      expression: "showConfirm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "preview",
    style: ({
      backgroundImage: ("url(" + (_vm.url+'?imageMogr2/thumbnail/20000@/auto-orient') + ")")
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfb2aef6"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/live/InteractionPublish.vue
// module id = 539
// module chunks = 1